import { InputWithLabel } from '@adotel/components'
import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import SearchIcon from '@material-ui/icons/Search'
import { memo } from 'react'

import PageHeader from '../../components/PageHeader'
import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import tenantPagesRoleManagement from '../../staticRoleManagement/tenantRoleManagement'
import useStyles from './styles/TenantsHeader.styles'

interface TenantsHeaderProps {
  searchInputValue: string | undefined

  setsearchInputValue: (val: string) => void
}
const TenantsHeader: React.FC<TenantsHeaderProps> = ({
  searchInputValue,
  setsearchInputValue
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <PageHeader title={getTranslate('Tenants List')} />
      <div className={classes.header}>
        <Typography variant="h3" gutterBottom>
          {getTranslate('Tenants List')}
        </Typography>
        {tenantPagesRoleManagement
          .find((item) => item.route === '/tenant')
          ?.rolesListWithWriteAccess?.includes(getRoleFromStorage()) && (
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            color="primary"
            component={LocalizedLink}
            to="/tenant/create">
            {getTranslate(isSmallScreen ? 'Add' : 'Add new Tenant')}
          </Button>
        )}
      </div>
      <div className={classes.root}>
        <InputWithLabel
          placeholder={getTranslate('Search by name')}
          autoComplete="off"
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          className={classes.searchInput}
          value={searchInputValue}
          onChange={(event) =>
            setsearchInputValue(
              convertPersianNumbersToEnglishNumbers(event.currentTarget.value)
            )
          }
        />
      </div>
    </div>
  )
}

export default memo(TenantsHeader)
